import api, { handleResponse, handleError } from './api';

const partyPatronService = {
  async list({ regionId = null, from = null, to = null } = {}) {
    try {
      const params = new URLSearchParams();
      if (regionId) params.set('regionId', regionId);
      if (from) params.set('from', from);
      if (to) params.set('to', to);
      const response = await api.get(`/partypatrons${params.toString() ? `?${params}` : ''}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async schedule({ brandId, regionId, dayActive, customMessage, promoCode, promoLink, paidAmountCents = 0, slotStatus = 'scheduled', guestGiftCents, hostGiftCents }) {
    try {
      const response = await api.post('/partypatrons', {
        brandId,
        regionId,
        dayActive,
        customMessage,
        promoCode,
        promoLink,
        paidAmountCents,
        slotStatus,
        guestGiftCents,
        hostGiftCents,
      });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** What the brand paid for a slot — gifts never exceed it, and a slot with nothing recorded is held. */
  async setPaid(id, paidAmountCents) {
    try {
      const response = await api.put(`/partypatrons/${id}/paid`, { paidAmountCents });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async setStatus(id, status) {
    try {
      const response = await api.put(`/partypatrons/${id}/status`, { status });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getReport(id) {
    try {
      const response = await api.get(`/partypatrons/${id}/report`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** One row per brand across every patron day it has run. `days = 0` is all time. */
  async brandReport(days = 0) {
    try { return handleResponse(await api.get('/partypatrons/reports/brands', { params: { days } })); } catch (error) { return handleError(error); }
  },
};

export default partyPatronService;
